import { useTranslations } from '@/i18n/translations';
import { Pill, type Tone } from '@leanin/ui';

import type { ResourceDesignedFor } from '@/lib/queries/resources';

// The text carries the distinction; tone is only a supporting cue.
const TONE: Record<ResourceDesignedFor, Tone> = {
  all_users: 'neutral',
  women: 'navy',
};

// Who a resource's content was made for. An unreviewed resource (null) shows
// nothing — a missing label must never read as "for everyone".
export function DesignedForPill({
  designedFor,
}: {
  designedFor: ResourceDesignedFor | null;
}) {
  const t = useTranslations('Resources');
  if (designedFor === null) return null;
  return (
    <Pill tone={TONE[designedFor]} size="xs">
      {t(`card.designedFor.${designedFor}`)}
    </Pill>
  );
}
